import { render, staticRenderFns } from "./waitExtract.vue?vue&type=template&id=57773657&scoped=true"
import script from "./waitExtract.vue?vue&type=script&lang=js"
export * from "./waitExtract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57773657",
  null
  
)

export default component.exports